<div mat-dialog-content>
  <ng-lottie [options]="optionsSigning" [ngClass]="{'display-none': status!=='signing'}" (animationCreated)="onAnimCreated($event, 'signing')"></ng-lottie>
  <ng-lottie [options]="optionsSuccess" id="successLottie" [ngClass]="{'display-none': status!=='success'}" (animationCreated)="onAnimCreated($event, 'success')"></ng-lottie>
  <ng-lottie [options]="optionsError" id="errorLottie" [ngClass]="{'display-none': status!=='error'}" (animationCreated)="onAnimCreated($event, 'error')"></ng-lottie>
  <ng-lottie [options]="optionsAlreadySigned" id="alreadySignedLottie" [ngClass]="{'display-none': status!=='already_signed'}" (animationCreated)="onAnimCreated($event, 'already_signed')"></ng-lottie>

  <ng-container *ngIf="status==='signing'">
    <p>{{ 'signing' | translate }}</p>
  </ng-container>
  <ng-container *ngIf="status==='success'">
    <h1>{{ 'congrats' | translate }}</h1>
    <p>{{ 'documentSigned' | translate }}</p>
  </ng-container>
  <ng-container *ngIf="status==='error'">
    <h1>{{ '500' | translate }}</h1>
    <p>{{ 'tryLater' | translate }}</p>
  </ng-container>
  <ng-container *ngIf="status==='already_signed'">
    <h1>{{ 'documentAlreadySigned' | translate }}</h1>
    <p>{{ 'thanksForUse' | translate }}</p>
  </ng-container>
</div>

<div mat-dialog-actions *ngIf="status==='success' || status==='error' || status==='already_signed'">
  <button class="btn btn-primary btn-w-100" (click)="finish(true)" *ngIf="status==='success'">{{ 'done' | translate }}</button>
  <button class="btn btn-warn btn-w-100" (click)="retry()" *ngIf="status==='error'">{{ 'tryAgain' | translate }}</button>
  <button class="btn btn-warn btn-w-100" (click)="retryAlsoSign()" *ngIf="status==='already_signed'">{{ 'alsoSign' | translate }}</button>
  <button class="btn btn-warn btn-underline btn-w-100" (click)="finish(true)" *ngIf="status==='error' || 'already_signed'">{{ 'exit' | translate }}</button>
</div>
